import React from 'react';
import { useMediaQuery } from 'react-responsive';
import './Footer.css';
import logo1 from '../assets/images/logo1.png';
import gzh from '../assets/images/gzh-1.jpg';


function CompanyLogo() {
  return(
    <div className='company'>
      <img className='logo' src={logo1} />
      <p>Connecting Chinese Around the World, Sharing a Prosperous Future</p>
    </div>
  );
}

function QRcode ({src,children}){
  return(
    <div className='QRcode'>
      <img src={src} className='QRimg'></img>
      <div>{children}</div>
    </div>
  );
}

function MoreInfo() {
  return(
    <div className='More'>
      {/* <p className='Followus'>Follow Us</p> */}

      <div className='QRList'>
        <QRcode src={gzh}>
          <p>Official Account</p>
        </QRcode>
        {/* <QRcode src={gzh}>
          <p>WeChat Group</p>
        </QRcode> */}
      </div>
      <p>Email: <a href="mailto:business@neohotech.com">business@neohotech.com</a></p>
    </div>
  );
}

function MobileFooter() {
  return(
    <footer className="footer">
    <p>Connecting Chinese Around the World, Sharing a Prosperous Future</p>
      <p>Email: <a href="mailto:business@neohotech.com">business@neohotech.com</a></p>
      <p className="footer-address">NeohoTech T8 Ginza Building 9F, Chuo-ku Ginza 3-2-12, Tokyo, Japan</p>
      <p>&copy;{new Date().getFullYear()} NeohoTech.com All Rights Reserved.</p>
    </footer>
  );
}

function DesktopFooter() {
  return (
    <footer className="footer">
      <div className="footer-upper">
        <CompanyLogo />
        {/* <div className="divider-vertical"></div> */}
        <MoreInfo />
      </div>
      <div className="divider-horizontal"></div>
      <div className="footer-bottom">
        <p className="footer-address">NeohoTech T8 Ginza Building 9F, Chuo-ku Ginza 3-2-12, Tokyo, Japan</p>
        <p>&copy;{new Date().getFullYear()} NeohoTech.com All Rights Reserved</p>
      </div>
    </footer>
  );
}

function Footer() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    return (
      <div className="">
        {isMobile ? <MobileFooter /> : <DesktopFooter />}
      </div>
    );
  };

  export default Footer;
